export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/stop-icon.svg?ad9bb391b8fa3c8ce16955edbb961d8f";